export default "/_next/static/fonts/FiveEyesCondensed-Bold-8c8fdbe11a5cf3feb6fb2401985ed789.woff";